<script lang="ts" setup>
import IconFilter from '@/components/Icons/IconFilter.vue'

const emit = defineEmits(['openFiltersDialog'])

defineProps({
  isFiltersActivated: {
    type: Boolean,
    required: true,
  },
  selectedFiltersCount: {
    type: Number,
    required: true,
  },
})

const openFiltersDialog = () => emit('openFiltersDialog')
</script>

<template>
  <div class="filter--widget">
    <v-badge
      v-if="isFiltersActivated"
      color="#F44336"
      :content="selectedFiltersCount"
      offset-x="8"
      offset-y="8"
    >
      <app-button
        width="48"
        height="48"
        icon
        class="button"
        @click="openFiltersDialog"
      >
        <icon-filter />
      </app-button>
    </v-badge>

    <app-button
      v-else
      width="48"
      height="48"
      icon
      class="button"
      @click="openFiltersDialog"
    >
      <icon-filter :active="false" />
    </app-button>
  </div>
</template>

<style lang="scss" scoped>
.filter--widget {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 8;
  padding: 25px;

  .button {
    background: $basket-success;
    box-shadow: 0 4px 30px rgba(65, 58, 91, 0.3);
  }
}
</style>
